import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../landing/AuthContext';
import { LoadingScreen } from '../../loadingscreen';

/**
 * Доступ только для авторизованных; иначе редирект на /login с возвратом на исходный URL.
 */
export function RequireAuth({ children }) {
    const LOGOUT_REDIRECT_FLAG = 'welland:logout-redirect-to-landing';
    const { isAuthenticated, loading } = useAuth();
    const location = useLocation();

    if (loading) {
        return <LoadingScreen />;
    }
    if (!isAuthenticated) {
        try {
            if (sessionStorage.getItem(LOGOUT_REDIRECT_FLAG) === '1') {
                sessionStorage.removeItem(LOGOUT_REDIRECT_FLAG);
                return <Navigate to="/" replace />;
            }
        } catch {
            // fallthrough to login redirect
        }
        return <Navigate to="/auth" state={{ from: location }} replace />;
    }
    return children;
}
